import { PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

function Portal({ rootSelector, children }: PropsWithChildren<{ rootSelector: string }>) {
    const [root, setRoot] = useState(null as Element | null);

    useEffect(() => {
        const root = document.querySelector(rootSelector);
        if (root) {
            root.innerHTML = '';
        }
        setRoot(root);
    }, [rootSelector]);

    if (!root) {
        return null;
    }
    return createPortal(children, root);
}

export default Portal;
